import { render, staticRenderFns } from "./Task_ApplyLeaveStudent.vue?vue&type=template&id=1bbc68dc&scoped=true&"
import script from "./Task_ApplyLeaveStudent.vue?vue&type=script&lang=js&"
export * from "./Task_ApplyLeaveStudent.vue?vue&type=script&lang=js&"
import style0 from "./Task_ApplyLeaveStudent.vue?vue&type=style&index=0&id=1bbc68dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbc68dc",
  null
  
)

export default component.exports